import { IconUsd, IconChf, IconYen, IconEur, IconGbp, IconInr, IconKrw } from '@hubble/icons';
import { jsx } from '@emotion/react/jsx-runtime';

const FIAT_ICON_MAP = {
  AUD: jsx(IconUsd, {}),
  BRL: jsx(IconUsd, {}),
  CAD: jsx(IconUsd, {}),
  CHF: jsx(IconChf, {}),
  CNY: jsx(IconYen, {}),
  COP: jsx(IconUsd, {}),
  EUR: jsx(IconEur, {}),
  GBP: jsx(IconGbp, {}),
  HKD: jsx(IconUsd, {}),
  INR: jsx(IconInr, {}),
  JPY: jsx(IconYen, {}),
  KRW: jsx(IconKrw, {}),
  NZD: jsx(IconUsd, {}),
  SGD: jsx(IconUsd, {}),
  USD: jsx(IconUsd, {})
};

export { FIAT_ICON_MAP };
